//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const loyaltyStyles = makeStyles(() => ({
  headingText: {
    padding: 10,
    textAlign: "center",
    fontSize: "1.25rem",
    fontFamily: "segoe-ui",
    backgroundColor: "#305698",
    color: "#fff",
  },
  headingText2Grid: {
    padding: "10px 50px 20px 0px",
    "@media (max-width: 768px)": {
      padding: 0,
      marginBottom: "100px",
    },
  },
  deactiveError:{
    color:"red",
    textAlign: "center",
    marginTop: "60px",

  },
  headingText2: {
    marginTop: 25,
    fontSize: "1.125rem",
    fontFamily: "segoe-ui",
    "@media (max-width: 768px)": {
      padding: 10,
    },
  },
  btnGrid: {
    padding: "0px 50px 20px 50px",
    fontSize: 20,
    alignSelf: "flex-end",
    "@media (max-width: 600px)": {
      padding: 10,
      textAlign: "right",
    },
  },
  submitBtn: {
    color: "#fff!important",
    backgroundColor: "#335796",
    fontSize: "22px!important",
    border: " 1px solid #335796",
    borderRadius: "10px!important",
    width: 150,
    height: 45,
    textTransform: "capitalize!important",
    fontFamily: "segoe-ui!important",
    "&:hover": {
      backgroundColor: "#335796!important",
    },
  },
  enrollBtn: {
    color: "#fff!important",
    backgroundColor: "#335796",
    fontSize: "15px!important",
    textTransform: "capitalize!important",
    fontFamily: "segoe-ui!important",
    "&:hover": {
      backgroundColor: "#335796!important",
    },
  },
  cancelBtn: {
    color: "#fff!important",
    backgroundColor: "#335796",
    fontSize: "15px!important",
    textTransform: "capitalize!important",
    fontFamily: "segoe-ui!important",
    "&:hover": {
      backgroundColor: "#335796!important",
    },
  },
  tableDiv: {
    padding: 20,
    "@media (max-width: 768px)": {
      padding: 0,
      marginBottom: "200px",
    },
  },
  active: {
    color: "green",
  },
  inActive: {
    color: "red",
  },
  toastCss: {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  },
  emptyDataText: {
    textAlign: "center",
    fontSize: 30,
    fontFamily: "segoe-ui",
    padding: "10%",
    opacity: "0.4",
  },
  roleInput: {
    width: "100%",
  },
  // Consent pending
  mainDiv: {
    textAlign: "center",
  },
  divText: {
    fontSize: 24,
    fontFamily: "segoe-ui!important",
    textAlign: "center",
    backgroundColor: "#dddddd",
  },
  divSubText: {
    fontSize: 16,
    fontFamily: "segoe-ui!important",
    textAlign: "left",
    padding: 20,
  },
}));
